export const HOST_ENVS = {
  development: 'development',
  production: 'production',
  staging: 'staging',
  standalone: 'standalone',
};
